export default "__VITE_ASSET__Bhz1uraf__"